import { post, put } from '../Services/http';
import { FAVOURITES_SET_LISTS } from '../ConstantsBrafab/constants';
import { getOfferPage } from '../ActionsBrafab/OfferPage.action';

const rootRoute = '/api/favourites';

export const add = (id, name, quantity) => {
    return () => {
        return post(`${rootRoute}/add`, { id, name, quantity })
            .then(response => response.json())
            .then(response => {
                if (response) {
                    return response;
                }
            });
    }
}

export const receive = (payload) => {
    return {
        type: FAVOURITES_SET_LISTS,
        payload: {
            favouriteLists: payload.favouriteLists,
        },
    };
};

export const changeList = (listId) => (dispatch, getState) => {
    var lists = getState().favourites;
    lists.favouriteLists.forEach(element => {element.selected = element.systemId == listId});
    dispatch(receive(lists))
}

export const setList = (listId, reload, favouriteListUrl, change) => (dispatch) => {
    return put(`${rootRoute}/list`, listId)
        .then(response => response.json())
        .then(response => {
            if (reload){
                location.reload();
            }
            else if (favouriteListUrl) {
                location.href = favouriteListUrl
            }
            else if (change) {
                dispatch(receive(response))
                dispatch(getOfferPage());
            }
            else
            {
                dispatch(receive(response))
            }
        })
}

export const createList = (listName, reload) => (dispatch, getState) => {
    var onOfferPage = document.getElementById('offerPage')
    return post(`${rootRoute}/list`, listName)
        .then(response => response.json())
        .then(response => {
                if (reload||onOfferPage){
                    location.reload();
                }
                else{
                    dispatch(receive(response))
                }
        })
}